import { render, staticRenderFns } from "./embedPageError.vue?vue&type=template&id=223125fa&scoped=true&"
import script from "./embedPageError.vue?vue&type=script&lang=js&"
export * from "./embedPageError.vue?vue&type=script&lang=js&"
import style0 from "./embedPageError.vue?vue&type=style&index=0&id=223125fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223125fa",
  null
  
)

export default component.exports